<template>
  <div id="dashboard-view">
    <ModalWindow />
    <VehicleTypeSelect />
    <div v-if="noVehicles" class="error-msg">
      No vehicles were found in your search. Please search again.
    </div>
    <div v-else>
      <div id="dashboard-head" class="row">
        <InfoBoxes />
      </div>
      <div v-if="isLoading" class="col-md-9">
        <LoadingSpinner />
      </div>
      <div class="container-div">
        <div v-if="!isLoading && mapData.length">
          <div class="row map-row">
            <FilterButtons />
            <div id="map-container" class="col-md-7">
              <DataMap :selected-map-data="mapData" />
            </div>
            <div class="col-md-4">
              <div class="county-table" v-if="!isLoading && mapData.length">
                <MapTable />
              </div>
            </div>
          </div>
          <div class="row chart-row">
            <div class="heatmap-container chart-container" v-if="!isLoading && dateData.length">
              <HeatMap :chartData=dateData />
            </div>
          </div>
          <div class="row chart-row">
            <div class=" chart-container" v-if="!isLoading && hasHistogramData">
              <HistogramCharts />
            </div>
            </div>
          <div class="row chart-row">
            <div class="chart-container" v-if="!isLoading && dateData.length">
              <VehicleTotalCharts />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  computed, onBeforeMount, watch,
} from 'vue';
import { useStore } from 'vuex';
import { isEqual } from 'lodash-es';
import DataMap from '@/components/DataMap.vue';
import VehicleTypeSelect from '@/components/VehicleTypeSelect.vue';
import InfoBoxes from '@/components/InfoBoxes.vue';
import FilterButtons from '@/components/FilterButtons.vue';
import MapTable from '@/components/MapTable.vue';
import HeatMap from '@/components/HeatMap.vue';
import HistogramCharts from '@/components/HistogramCharts.vue';
import VehicleTotalCharts from '@/components/VehicleTotalCharts.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import ModalWindow from '@/components/ModalWindow.vue';

const store = useStore();
const isLoading = computed(() => store.getters.isDataLoaded);
const mapData = computed(() => store.getters.getMapData);
const dateData = computed(() => store.getters.getDateInfo);
const noVehicles = computed(() => store.getters.getNoVehicleError);
onBeforeMount(() => {
  store.dispatch('fetchLoadingData');
});

const hasHistogramData = computed(() => {
  const histData = store.getters.getHistogramData;
  const hasLength = histData && Object.keys(histData).length >= 1;
  return hasLength;
});

watch(() => store.getters.getApiFilters, (newFilters, oldFilters) => {
  const loading = store.getters.getLoadingDropdown;
  const hasNone = newFilters.weight_class === 'none' || newFilters.vocation_id === 'none';

  if (oldFilters === undefined && !hasNone) {
    store.dispatch('fetchDashboardData', newFilters);
  } else if (!isEqual(newFilters, oldFilters) && !loading && !hasNone) {
    store.dispatch('fetchDashboardData', newFilters);
  }
  return false;
}, {
  immediate: true,
});
</script>
